// Shared module-level cache for full EBIS WO payloads.
// WorkOrderTab and TraxxallDueList both read from ebis_wo_cache (Supabase)
// and write here so the same WO is only fetched once per page session.
export const woPayloadStore = {}  // { [workOrderNumber]: { payload, cachedAt } }
